// @ts-nocheck
import { produce, castDraft } from "immer";
import {
    type GetAffectedGroupsQuery,
    type GetCachedAffectedGroupsQuery,
} from "../queries/getAffectedGroups.gql-generated";

export class AffectedGroupsOperations {
    public static concat(cacheData: GetCachedAffectedGroupsQuery, loadedData: GetAffectedGroupsQuery) {
        if (!loadedData) {
            return cacheData;
        }

        return produce(cacheData, (draft) => {
            draft.getAffectedGroups.cursor = loadedData.getAffectedGroups.cursor;
            draft.getAffectedGroups.affectedGroups.push(...castDraft(loadedData.getAffectedGroups.affectedGroups));
        });
    }
}
